import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader.service';
import {
  AuthenticationStore,
  ForgetPasswordObject,
  ForgetPasswordResponse,
  ResetPasswordObject,
  SignUp,
  SocailLogInVeriify,
} from 'src/app/stores/authentication.store';
import { SellerSignUp, SellerStore } from 'src/app/stores/seller.store';
import { MobileVerifyComponent } from '../mobile-verify/mobile-verify.component';
import { SuccessfulCreatedComponent } from '../successful-created/successful-created.component';
import { TranslateService } from '@ngx-translate/core';
import { ResetPasswordPage } from 'src/app/reset-password/reset-password.page';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.page.html',
  styleUrls: ['./otp.page.scss'],
})
export class OtpPage implements OnInit {
  @Input() signUpPayload: SignUp;
  @Input() sellerSignUpPayload: SellerSignUp;
  @Input() socailSignUpPayload: SocailLogInVeriify;
  @Input() payload: ForgetPasswordResponse;
  @Input() pageType: boolean;

  validations_form: FormGroup;
  otp: string;
  seconds: number = 31;
  interval = null;
  disableSubmit: boolean = false;

  constructor(
    private FormBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private loaderService: LoaderService,
    private authenticationStore: AuthenticationStore,
    private route: Router,
    private sellerStore: SellerStore,
    private translate: TranslateService,
    public platform: Platform
  ) {}

  ngOnInit() {
    this.setResendTime();
    this.validations_form = this.FormBuilder.group({
      otp1: new FormControl('', Validators.compose([Validators.required])),
      otp2: new FormControl('', Validators.compose([Validators.required])),
      otp3: new FormControl('', Validators.compose([Validators.required])),
      otp4: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  async mobileVerify() {
    this.otp =
      this.validations_form.value.otp1 +
      this.validations_form.value.otp2 +
      this.validations_form.value.otp3 +
      this.validations_form.value.otp4;
    if (this.sellerSignUpPayload && !this.signUpPayload) {
      this.sellerVerifyAndRegister();
    } else if (this.signUpPayload) {
      this.signUp();
    } else if (this.socailSignUpPayload) {
      this.socailSignUp();
    } else {
      this.resetPassword();
    }
    this.setResendTime();
  }

  setResendTime() {
    this.disableSubmit = true;
    this.interval = setInterval(() => {
      this.seconds = this.seconds - 1;
      if (this.seconds == 0) {
        this.clearInterval();
      }
    }, 1000);
  }

  clearInterval() {
    clearInterval(this.interval);
    this.disableSubmit = false;
    this.seconds = 31;
  }

  async sellerVerifyAndRegister() {
    this.loaderService.showLoading();
    var otp = {
      otp: this.otp,
    };
    try {
      await this.sellerStore.verifyOtp(otp);
      this.loaderService.dismissLoading();
      this.sellerSignUp();
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data,
        'middle',
        'danger',
        2000
      );
      this.clearInterval();
    }
  }

  async sellerSignUp() {
    this.loaderService.showLoading();
    try {
      const resp: any = await this.sellerStore.sellerSignUp(
        this.sellerSignUpPayload
      );
      this.authenticationStore.userInfo.seller = resp.data;
      this.loaderService.dismissLoading();
      this.modalCtrl.dismiss();
      const modal = await this.modalCtrl.create({
        component: SuccessfulCreatedComponent,
        cssClass: 'Successful-Created',
        backdropDismiss: true,
      });
      modal.present();
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data,
        'middle',
        'danger',
        2000
      );
      this.clearInterval();
    }
  }

  async signUp() {
    this.signUpPayload.otp = this.otp;
    this.loaderService.showLoading();
    try {
      await this.authenticationStore.signUp(this.signUpPayload).then((data) => {
        const resp: any = data;
        if (resp.status == 1) {
          localStorage.setItem('authToken', resp.data.token);
          this.authenticationStore.userInfo = resp.data;
          this.authenticationStore.token = resp.data.token;
          this.authenticationStore.isLogin.next(true);
        }
      });
      this.loaderService.dismissLoading();
      this.dismiss();
      const modal = await this.modalCtrl.create({
        component: MobileVerifyComponent,
        cssClass: 'mobile-verify',
        backdropDismiss: true,
      });
      modal.present();
      this.route.navigate(['/dashboard']);

      this.validations_form.reset();
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data,
        'middle',
        'danger',
        2000
      );
      this.clearInterval();
    }
  }
  ionViewWillLeave() {
    // Dismiss the modal before leaving the page
    this.modalCtrl.dismiss();
  }
  async resetPassword() {
    var data: ResetPasswordObject = {
      id: this.payload.id,
      otp: this.otp,
    };
    this.loaderService.showLoading();
    try {
      await this.authenticationStore.resetPassword(data);
      this.loaderService.dismissLoading();
      this.dismiss();

      if (this.platform.is('mobile')) {
        const navigationExtras: NavigationExtras = {
          state: {
            id: this.payload.id,
          },
        };
        this.route.navigate(['/reset-password'], navigationExtras);
      } else {
        const modal = await this.modalCtrl.create({
          component: ResetPasswordPage,
          cssClass: 'Successful-Created',
          componentProps: {
            payloadId: this.payload.id,
          },
        });
        modal.present();
      }
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(error.error.data, 'middle', 'danger');
    }
  }
  next(event, focusNext, focusPrev) {
    if (
      event.code == 'Backspace' ||
      event.key == 'Backspace' ||
      event.keyCode == 8
    ) {
      if (focusPrev != null) {
        focusPrev.setFocus();
      }
    } else {
      if (focusNext != null) {
        focusNext.setFocus();
      }
    }
  }

  async socailSignUp() {
    this.socailSignUpPayload.otp = this.otp;
    this.loaderService.showLoading();
    try {
      await this.authenticationStore
        .signUpSocial(this.socailSignUpPayload)
        .then((data) => {
          const resp: any = data;
          if (resp.status == 1) {
            localStorage.setItem('authToken', resp.data.token);
            this.authenticationStore.userInfo = resp.data;
            this.authenticationStore.token = resp.data.token;
          }
        });
      this.loaderService.dismissLoading();
      this.dismiss();
      const modal = await this.modalCtrl.create({
        component: MobileVerifyComponent,
        cssClass: 'mobile-verify',
        backdropDismiss: true,
      });
      modal.present();
      if (this.pageType) {
        this.dismiss();
      } else {
        this.authenticationStore.isLogin.next(true);
        this.route.navigate(['/dashboard']);
      }
      this.validations_form.reset();
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data,
        'middle',
        'danger',
        2000
      );
      this.clearInterval();
    }
  }

  async resend() {
    this.setResendTime();
    this.loaderService.showLoading();
    try {
      if (this.signUpPayload) {
        await this.authenticationStore.signUp(this.signUpPayload);
      } else if (this.sellerSignUpPayload) {
        await this.sellerStore.verifyMobile({
          phone: this.sellerSignUpPayload.phone,
        });
      } else if (this.socailSignUpPayload) {
        await this.authenticationStore.signUpSocial(this.socailSignUpPayload);
      } else {
        await this.authenticationStore.forgetPassword({
          email: this.payload.email,
        });
      }
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        this.translate.instant('COMPANY_SELLER.OTP_SENT_MESSAGE'),
        'bottom',
        'success',
        2000
      );
    } catch (error) {
      this.loaderService.presentToast(
        error.error.data,
        'middle',
        'danger',
        3000
      );
      this.loaderService.dismissLoading();
    }
  }
  
  dissmissModal() {
    this.modalCtrl.dismiss();
  }
}
